import chests from "./chests/index.jsx";
import plants from "./plants/index.jsx";

export default {
  chests,
  plants,
};
